import React from 'react';
import { BarChart3Icon, TargetIcon, ClockIcon, TrendingUpIcon } from 'lucide-react';
import type { ViewType } from '../../types';
interface SidebarProps {
  activeView: ViewType;
  onViewChange: (view: ViewType) => void;
}
const navItems: {
  view: ViewType;
  label: string;
  icon: React.ReactNode;
}[] = [{
  view: 'dashboard',
  label: 'Dashboard',
  icon: <BarChart3Icon className="w-5 h-5" data-id="element-238" />
}, {
  view: 'goals',
  label: 'Goal Settings',
  icon: <TargetIcon className="w-5 h-5" data-id="element-239" />
}, {
  view: 'history',
  label: 'History',
  icon: <ClockIcon className="w-5 h-5" data-id="element-240" />
}];
export function Sidebar({
  activeView,
  onViewChange
}: SidebarProps) {
  return <nav className="fixed left-0 top-0 bottom-0 w-60 bg-slate-800 text-white flex flex-col z-30" aria-label="Main navigation" data-id="element-241">
      {/* Logo / App Title */}
      <div className="flex items-center gap-3 px-5 py-6 border-b border-slate-700" data-id="element-242">
        <div className="w-9 h-9 rounded-lg bg-blue-500 flex items-center justify-center flex-shrink-0" data-id="element-243">
          <TrendingUpIcon className="w-5 h-5 text-white" data-id="element-244" />
        </div>
        <div data-id="element-245">
          <h1 className="text-base font-bold leading-tight" data-id="element-246">Goal Tracker</h1>
          <p className="text-xs text-slate-400 leading-tight" data-id="element-247">
            Performance Metrics
          </p>
        </div>
      </div>

      {/* Navigation */}
      <div className="flex-1 py-4 px-3 space-y-1" data-id="element-248">
        {navItems.map(item => {
        const isActive = activeView === item.view;
        return <button key={item.view} onClick={() => onViewChange(item.view)} className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${isActive ? 'bg-blue-600 text-white shadow-sm' : 'text-slate-300 hover:bg-slate-700 hover:text-white'}`} aria-current={isActive ? 'page' : undefined} aria-label={`Navigate to ${item.label}`} data-id="element-249">
              {item.icon}
              {item.label}
            </button>;
      })}
      </div>

      {/* Footer */}
      <div className="px-5 py-4 border-t border-slate-700" data-id="element-250">
        <p className="text-xs text-slate-500" data-id="element-251">© 2026 Loan Performance</p>
      </div>
    </nav>;
}